var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7631 6.23282C18.0735 6.54325 18.0735 7.04792 17.7631 7.35835L13.1255 12.0003L17.7672 16.6376C18.0776 16.948 18.0776 17.4527 17.7672 17.7631C17.4567 18.0735 16.9519 18.0734 16.6415 17.7629L11.9997 13.1255L7.36242 17.7672C7.05199 18.0776 6.54732 18.0776 6.23689 17.7672C5.92646 17.4567 5.92663 16.9519 6.23706 16.6415L10.8745 11.9997L6.23265 7.36225C5.92239 7.0518 5.92245 6.54726 6.23282 6.23689C6.54325 5.92646 7.04809 5.92663 7.35852 6.23706L12.0003 10.8745L16.6376 6.23282C16.948 5.92239 17.4527 5.92239 17.7631 6.23282Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon_close.6827c6067cb4a148d228eb9972de31c0.svg";
export { ForwardRef as ReactComponent };